import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const {
    StyledTextHeader,
    StyledTitle,
    StyledSubTitle,
    StyledTitleLarge,
    StyledSubTitleLarge,
} = Styles;

export const TextHeader = ({ title, subTitle, large, ...otherProps }) => (
    <StyledTextHeader large={large} {...otherProps}>
        {large ? (
            <>
                <StyledTitleLarge>{title}</StyledTitleLarge>
                {subTitle ? <StyledSubTitleLarge>{subTitle}</StyledSubTitleLarge> : null}
            </>
        ) : (
            <>
                <StyledTitle>{title}</StyledTitle>
                {subTitle ? <StyledSubTitle>{subTitle}</StyledSubTitle> : null}
            </>
        )}
    </StyledTextHeader>
);

TextHeader.propTypes = {
    subTitleColor: PropTypes.string,
    titleColor: PropTypes.string,
    title: PropTypes.node,
    subTitle: PropTypes.node,
    large: PropTypes.bool,
};

TextHeader.defaultProps = {
    subTitleColor: '',
    titleColor: '',
    title: '',
    subTitle: '',
    large: false,
};

TextHeader.Styles = Styles;
